import { Slot } from '@radix-ui/react-slot';
import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

// atom — DWR signature block. Sfondo --ink + testo --paper-bright, Cinzel uppercase.
// Vedi mockup .ink-block / .ink-block--xl / .ink-block--full
// (dev-workspace/mockups/.../project/styles.css righe 95-116).
// Polimorfo via asChild + Radix Slot (stesso pattern dei <Button> shadcn del progetto).

type InkBlockVariant = 'default' | 'xl' | 'full';

interface InkBlockProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: InkBlockVariant;
  asChild?: boolean;
  children?: ReactNode;
}

const VARIANT_CLASSES: Record<InkBlockVariant, string> = {
  default: 'inline-block px-3.5 py-1.5 text-[0.92rem] tracking-[0.1em]',
  xl: 'inline-block px-3 py-2 text-2xl tracking-[0.07em]',
  full: 'block w-full px-3.5 py-1.5 text-[0.92rem] tracking-[0.1em]',
};

export function InkBlock({
  variant = 'default',
  asChild = false,
  className,
  children,
  ...rest
}: InkBlockProps) {
  const Comp = asChild ? Slot : 'span';
  return (
    <Comp
      className={cn(
        'bg-ink text-paper-bright font-display font-bold uppercase leading-tight',
        VARIANT_CLASSES[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </Comp>
  );
}
